import { APP_THEME_DEFAULT, APP_THEME_SABLE } from '../../common/src';

const SYSTEM_FONTS = 'var(--font-sans-system)'; // published by tailwind.config.js

export const THEME_CONFIG = {
  [APP_THEME_DEFAULT]: {
    // transparent keeps center-supplied customCSS body backgrounds visible, as before theming
    appBackgroundColor: 'transparent',
    headerBackgroundColor: 'var(--color-primary-500)',
    showFooter: true,
    // naming no webfont is what keeps the default theme from downloading one
    fontSans: SYSTEM_FONTS,
    fontHeading: SYSTEM_FONTS,
  },
  [APP_THEME_SABLE]: {
    appBackgroundColor: '#EDF2F5',
    headerBackgroundColor: '#fff',
    showFooter: false,
    fontSans: `'Inter Variable', ${SYSTEM_FONTS}`,
    fontHeading: `'Poppins', ${SYSTEM_FONTS}`,
  },
};
